export interface MedplumAppConfig {
  /** A non-default Medplum server. Local stack only; see `main.tsx`. */
  medplumBaseUrl?: string;
  clientId?: string;
  recaptchaSiteKey?: string;
  patientPortalUrl?: string;
  /**
   * payment-frontend's origin, used to rebuild the payment page for a leg that
   * already exists so re-delivering a link never mints a second one. Unset means
   * the Copy/Resend actions do not render at all — a feature missing beats a
   * broken URL handed to a patient. See `paymentLinkForLeg`.
   */
  paymentFrontendUrl?: string;
  /**
   * The Everself Organization — `Claim.provider` on employer-benefit pre-authorizations
   * (BAR-2593). Unset means the benefit drawer refuses to write rather than send a Claim with
   * no provider.
   */
  everselfOrganizationId?: string;
}

/** Mirrors `FRONTEND_DOMAIN` on each `bariendo-payment-backend` Cloud Run service. */
const PAYMENT_FRONTEND_BY_MODE: Record<string, string> = {
  staging: 'https://staging-pay.everself.com',
  production: 'https://pay.everself.com',
};

/** Hand-created in each Medplum project, like the payor Organizations bariendo-be references. */
const EVERSELF_ORGANIZATION_BY_MODE: Record<string, string> = {
  staging: '0e908716-58ca-4049-97c1-1bc540bf37fe',
  production: 'a3c24c4e-9de6-4940-9ac5-d485bdceee72',
};

const config: MedplumAppConfig = {
  medplumBaseUrl: import.meta.env?.VITE_MEDPLUM_BASE_URL,
  clientId: import.meta.env?.VITE_MEDPLUM_CLIENT_ID,
  recaptchaSiteKey: import.meta.env?.VITE_RECAPTCHA_SITE_KEY,
  patientPortalUrl: import.meta.env?.VITE_PATIENT_PORTAL_URL,
  // `||`, not `??`: an unset `vars.VITE_PAYMENT_FRONTEND_URL` arrives as an empty string.
  paymentFrontendUrl:
    import.meta.env?.VITE_PAYMENT_FRONTEND_URL || PAYMENT_FRONTEND_BY_MODE[import.meta.env?.MODE ?? ''],
  everselfOrganizationId:
    import.meta.env?.VITE_EVERSELF_ORGANIZATION_ID || EVERSELF_ORGANIZATION_BY_MODE[import.meta.env?.MODE ?? ''],
};

export function getConfig(): MedplumAppConfig {
  return config;
}
